import client from "./client";

const endpoint = "admin/";

const reservationReport = ({ body }) =>
  client.post(endpoint + "reservation-report", body);
//test
export { reservationReport };
